export function updateOptionSeries (option, query, content) {
  if (option['series']) {
    for (var i = 0; i < option['series'].length; i++) {
      if (Object.keys(query)[0] in option['series'][i]) {
        if (option['series'][i][Object.keys(query)[0]] === query[Object.keys(query)[0]]) {
          break
        }
      }
    }
    if (i < option['series'].length) {
      option['series'][i] = content
    } else {
      option['series'].push(content)
    }
  }
}

export function removeOptionSeries (option, query) {
  if (option['series']) {
    for (var i = 0; i < option['series'].length; i++) {
      if (option['series'][i]['name']) {
        if (option['series'][i]['name'] === query) {
          option['series'].splice(i, 1)
        }
      }
    }
  }
}

export function updateOptionLegend (option, name) {
  if (option['legend']) {
    if ('data' in option['legend']) {
      for (var i = 0; i < option['legend']['data'].length; i++) {
        if (name === option['legend']['data'][i]) {
          break
        }
      }
      if (i === option['legend']['data'].length) {
        option['legend']['data'].push(name)
      }
    } else {
      option['legend'] = {show: true, data: [name]}
    }
  }
}

export function removeOptionLegend (option, name) {
  if (option['legend']) {
    if ('data' in option['legend']) {
      for (var i = 0; i < option['legend']['data'].length; i++) {
        if (name === option['legend']['data'][i]) {
          option['legend']['data'].splice(i, 1)
        }
      }
    }
  }
}

export function updateOptionIndexForDraw (option, labels, drawData, indexForDraw, name) {
  let collec = labels.concat(drawData.labels).sort()
  let collection = Array.from(new Set(collec))
  var valueData = []
  let m = 0
  for (let i = 0; i < collection.length; i++) {
    let dy = false
    for (let j = m; j < drawData.labels.length; j++) {
      if (collection[i] < drawData.labels[0]) {
        valueData[i] = null
        break
      } else if (collection[i] === drawData.labels[j]) {
        valueData[i] = drawData.values[j]
        m = j
        dy = true
        break
      } else if (dy === false && j === drawData.labels.length - 1) {
        valueData[i] = valueData[i - 1]
        break
      }
    }
  }
  let start = collection.indexOf(labels[0])
  let end = collection.indexOf(labels[labels.length - 1]) + 1
  collection = collection.slice(start, end)
  valueData = valueData.slice(start, end)
  var valueDatas = []
  for (let j = 0; j < labels.length; j++) {
    if (collection.indexOf(labels[j]) > -1) {
      let i = collection.indexOf(labels[j])
      valueDatas.push(valueData[i])
    }
  }
  let maxDraw = Math.max.apply(null, valueDatas)
  let minDraw = Math.min.apply(null, valueDatas)
  option['xAxis'] = {
    type: 'category',
    data: labels,
    // 网格样式
    splitLine: {
      show: true
    }
  }
  option['yAxis'] = [
    {
      name: name,
      type: 'value',
      min: 'dataMin',
      max: 'dataMax',
      axisLabel: {
        formatter: '{value}'
      }
    },
    {
      type: 'value',
      name: indexForDraw[0]['name'],
      min: minDraw,
      max: maxDraw
    }
  ]
  var query = {
    'key': '额外数据1'
  }
  var content = {
    'name': indexForDraw[0]['name'],
    'key': '额外数据1',
    'type': 'line',
    'data': valueDatas,
    'yAxisIndex': 1
  }
  updateOptionLegend(option, indexForDraw[0]['name'])
  updateOptionSeries(option, query, content)
}



// WEBPACK FOOTER //
// ./src/api/updateGraphOption.js